<div class="page-content page-fill">
  @if (!memberCode) {
    <div class="card">
      @if (!memberCode) {
        <div class="card-body">
          <h2>No Member Information Found. Verify portal login</h2>
          <dx-text-box style="min-width: 300px; max-width: 500px" [label]="'Member Email'" [(value)]="memberEmailSubmit"></dx-text-box>
          <dx-text-box style="min-width: 300px; max-width: 500px" [label]="'Member Code'" [(value)]="memberCodeSubmit"></dx-text-box>
          <button class="btn btn-sm btn-primary mt-2" (click)="submitMemberCode()">Submit</button>
        </div>
      }
    </div>
  }

  @if (familyInfo) {
    <div>
      <h1>Household Information</h1>
      <div class="dx-toolbar mb-3">
        <h2 class="d-block ms-4">{{ familyInfo?.Name }}</h2>
      </div>
      <div class="d-flex">
        <dx-form [formData]="familyInfo" [colCount]="2" class="flex-fill">
          <dxi-item [itemType]="'group'" [colCount]="2">
            @if (!familyInfo.isHomePhoneUnlisted) {
              <dxi-item dataField="HomePhone" [label]="{ text: 'Phone' }"></dxi-item>
            }
            <dxi-item dataField="isHomePhoneUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
            <dxi-item dataField="Address1" [colSpan]="2"></dxi-item>
            <dxi-item dataField="Address2" [colSpan]="2"></dxi-item>
            <dxi-item dataField="City"></dxi-item>
            <dxi-item dataField="State"></dxi-item>
            <dxi-item dataField="Zip"></dxi-item>
            <dxi-item dataField="Country"></dxi-item>
            <dxi-item dataField="household" [label]="{ text: 'Household' }" [editorOptions]="{ readOnly: true }"> </dxi-item>
          </dxi-item>
        </dx-form>
        @if (photoUrl) {
          <div class="ms-3 d-flex flex-column" style="width: 300px;">
            <div style="text-align: center; font-weight: bold">Current Directory Photo</div>
            @if (!photoUrl) {
              <div style="text-align: center">No Image Found</div>
            }
            <img src="{{ photoUrl }}" class="w-100" />
          </div>
        }
      </div>
      @if (family) {
        <dx-data-grid
          #familyPeopleGrid
          class="mt-3"
          keyExpr="Id"
          [dataSource]="family.members"
          height="300px"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-column dataField="FirstName"></dxi-column>
          <dxi-column dataField="LastName"></dxi-column>
          <dxi-column dataField="Relationship"></dxi-column>
          <dxi-column dataField="HomePhone"></dxi-column>
          <dxi-column dataField="CellPhone"></dxi-column>
          <dxi-column dataField="Birthday"></dxi-column>
          <dxi-column dataField="Email"></dxi-column>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <dx-button class="btn btn-sm btn-success" text="Print Member Info Sheets" type="success" (onClick)="printMemberInfo()"></dx-button>
          </div>
        </dx-data-grid>
      }
      <div style="border: solid; border-width: '1px'">
        <h1 class="mt-3 ms-3">Upload Directory Photo</h1>
        @if (true) {
          <dx-file-uploader
            selectButtonText="Select photos"
            [multiple]="true"
            accept="image/*"
            uploadMode="useButtons"
            [maxFileSize]="5000000"
            (onUploaded)="photoUploaded()"
            [uploadUrl]="serviceName + '/api/utility/UploadMemberPhotoViaCode/' + memberCode"
            [uploadHeaders]="uploadHeaders"
            >
          </dx-file-uploader>
        }
      </div>
    </div>
  }
</div>
